// extracted by mini-css-extract-plugin
module.exports = {"recording":"guest-module--recording--2VP-a","guestimg":"guest-module--guestimg--3MbSP","guestblack":"guest-module--guestblack--3MXzF","guestgray":"guest-module--guestgray--2WUXr"};